import { Injectable } from '@angular/core';
import { INDRACurrency, INDRAAmmount } from '@ibe.models/calendar-price.indra.model.lib';
import { SESSION_VAR_KEY_CURRENCY, CURRENCIES_SYMBOLS, SESSION_VAR_KEY_MARKET, DEFAULT_DECIMAL_PLACES } from '@ibe.config';
import { getCurrencySymbol } from '@angular/common';


@Injectable({
	providedIn: 'root'
})
export class INDRACurrencyService {

	constructor() { }

    // get currency symbol based on stored currency
	INDRA_getCurrencySymbol(currency?: string): INDRACurrency {
		const storedCurrency = currency ? currency : sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY);
		return {
			name: storedCurrency,
			unit: CURRENCIES_SYMBOLS[storedCurrency] && CURRENCIES_SYMBOLS[storedCurrency].currencySymbol ? CURRENCIES_SYMBOLS[storedCurrency].currencySymbol : storedCurrency,
			highlightSymbol:
				CURRENCIES_SYMBOLS[storedCurrency] && CURRENCIES_SYMBOLS[storedCurrency].highlightSymbol ? CURRENCIES_SYMBOLS[storedCurrency].highlightSymbol :
				CURRENCIES_SYMBOLS.dollar.highlightDollar.includes(storedCurrency) ? CURRENCIES_SYMBOLS.dollar.currencySymbol : getCurrencySymbol(storedCurrency, 'narrow', 'pt-PT')
		};
	}

	INDRA_getCurrency() {
		const storedCurrency  = sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY);
		return storedCurrency;
	}

	INDRA_getPrice(ammount: any, priceUnit: string) {
		if (ammount) {
			return priceUnit === 'cash' ?
				ammount.currency.value ? `${this.INDRA_formatCash(ammount.currency.value)} ${ammount.currency.unit}` : '' :
				ammount.points ? `${this.INDRA_formatMiles(ammount.points)} M` : '';
		} else {
			return '';
		}
	}

	INDRA_formatCash(price, locale?) {
		const market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
		const sessionDecimals = sessionStorage.getItem('decimals');
		const decimals = sessionDecimals ? isNaN(+sessionDecimals) ? DEFAULT_DECIMAL_PLACES : +sessionDecimals : DEFAULT_DECIMAL_PLACES;

		return (+price).toLocaleString(market, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
	}

	INDRA_formatMiles(price, locale?) {
		const market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
		return (+price.toFixed(0)).toLocaleString(market);
	}


	INDRA_formatNumber(value, locale?) {
		const market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);

		return (+value).toLocaleString(market, { minimumFractionDigits: 0, maximumFractionDigits: 15 });
	}
	
	INDRA_getDecimalPlaces() {
		const sessionDecimals = sessionStorage.getItem('decimals');
		const decimals = sessionDecimals ? isNaN(+sessionDecimals) ? DEFAULT_DECIMAL_PLACES : +sessionDecimals : DEFAULT_DECIMAL_PLACES;
		return decimals;
	}
}
